import { useState } from 'react';
import { useRequest } from 'ahooks';
import {
  Title,
  Form,
  Dropdown,
  FieldRow,
  Footer,
  ButtonWithArrowRight,
} from '~components';
import { Selected, Values } from './types';
import * as Styled from './styled';
import validationSchema from './validation';
import { useTransshipment } from '~contexts/TranshipmentContext';
import { Representative } from '~services';
import { TRepresentative } from '~services/Representative';

function GuarantorMaritalStatus() {
  const transshipment = useTransshipment();
  const [maritalState, setMaritalState] = useState(false);
  const initialValues = {
    maritalStatus: '',
    communityPropertyRegime: '',
  };

  const { runAsync: addMaritalStatus, loading: IsLoadingAddMaritalStatus } =
    useRequest(Representative.addMaritalStatus, {
      manual: true,
    });

  const MaritalStatusOptions = [
    { id: 'married', value: 'Casado' },
    { id: 'single', value: 'Solteiro' },
    { id: 'divorced', value: 'Divorciado' },
    { id: 'widower', value: 'Viúvo' },
  ];

  const communityPropertyRegimeOptions = [
    { id: 'partial-community-of-property', value: 'Comunhão parcial de bens' },
    { id: 'community-of-property', value: 'Comunhão total de bens' },
    { id: 'full-separation-of-property', value: 'Separação de Bens' },
    {
      id: 'community-of-acquets',
      value: 'Participação final nos aquestos',
    },
  ];

  const handleSelectState = (selected: Selected) => {
    selected.value === 'Casado'
      ? setMaritalState(true)
      : setMaritalState(false);
  };

  const handleSubmit = async (values: Values) => {
    await addMaritalStatus(transshipment?.id, {
      marital_status: values.maritalStatus,
      marriage_regime: values.communityPropertyRegime,
    });

    transshipment.nextStep({
      ...transshipment,
      type: 'representative',
      data: {
        ...transshipment.data,
        marital_status: values.maritalStatus,
        marriage_regime: values.communityPropertyRegime,
      } as TRepresentative,
    });
  };

  return (
    <Form<Values>
      onSubmit={handleSubmit}
      initialValues={initialValues as Values}
      validationSchema={validationSchema}
      aria-labelledby="form-document"
    >
      <Styled.Container>
        <Styled.Content>
          <Title>Avalista das operações</Title>
          <Styled.Subtitle>
            Para possíveis operações futuras de crédito, você deverá assinar
            como avalista
          </Styled.Subtitle>
          <Styled.Description variant="sub200">
            Sendo assim, precisamos saber se você é casado ou possui uma relação
            estável com comunhão total ou parcial dos bens.
          </Styled.Description>
          <FieldRow>
            <Dropdown
              name="maritalStatus"
              label="Estado civil *"
              width="100%"
              placeholder="Selecione o estado civil"
              options={MaritalStatusOptions}
              onSelect={handleSelectState}
            />
            {maritalState && (
              <Dropdown
                name="communityPropertyRegime"
                label="Regime de comunhão de bens *"
                width="100%"
                placeholder="Selecione o regime"
                options={communityPropertyRegimeOptions}
              />
            )}
          </FieldRow>
        </Styled.Content>
        <Footer
          marginTop="auto"
          rightButton={
            <ButtonWithArrowRight
              width="100%"
              type="submit"
              variant="primary"
              disabled={IsLoadingAddMaritalStatus}
              loading={IsLoadingAddMaritalStatus}
            >
              Continuar
            </ButtonWithArrowRight>
          }
        />
      </Styled.Container>
    </Form>
  );
}

export default GuarantorMaritalStatus;
